
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from '../../../../../Helper/Context'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { FinancialYearDataDDL } from '../../../../../Components/CommonDDL/FinancialYearDataDDL'
import { MonthDataDDL } from '../../../../../Components/CommonDDL/MonthDataDDL'
import { ExcelPillerWiseUpload } from './Modal/ExcelPillerWiseUpload'
import { Get_M_Ward_Wise_PillerNo_SelectTableDataAPI } from '../../../../../Redux/ElectricalSlice/PillerWiseBenchMarkSlice'
import { Loading } from '../../../../../Helper/Loading'
import { ExcelPillerWiseUploadData } from './Modal/ExcelPillerWiseUploadData'
import PillerWiseBenchMarkModal from './Modal/PillerWiseBenchMarkModal'
import { VendorNameDDL } from '../../../../../Components/CommonDDL/VendorNameDDL'


export const PillerWiseDownloadBenchMark = (props) => {

    const {
        setUploadData,
        WardName,
        setWardName,
        FinancialYear,
        setFinancialYear,
        Month,
        setMonth,
        VendorName,
        setVendorName
    } = props
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [tableData, settableData] = useState([])
    const [IsPost, setIsPost] = useState(false)
    const [IsShowDownloadExcel, setIsShowDownloadExcel] = useState(false)

    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [DesignationPopupShow, setDesignationPopupShow] = useState()
    const [ShowAction, setShowAction] = useState(false)


    const handleClear = () => {
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setFinancialYear({
            ...FinancialYear,
            ID: 0,
            Label: 'Select...',
        })
        setMonth({
            ...Month,
            ID: 0,
            Label: 'Select...',
        })
        setVendorName({
            ...VendorName,
            ID: 0,
            Label: 'Select...',
        })
        settableData([])
    }

    useEffect(() => {
        setIsShowDownloadExcel(false)
    }, [WardName?.ID, FinancialYear?.ID, Month?.ID])


    const handleGetData = () => {
        setIsShowDownloadExcel(false)
        const data = {
            M_FinancialYearID: FinancialYear?.ID,
            M_MonthID: Month?.ID,
            M_WardID: WardName?.ID,
            M_Ward_Wise_VendorID: VendorName?.ID,
            M_ELEC_PillerID: '0',
            UserID: UserID,
            token: token,
            settableData: settableData,
            handleData: handleData,
            From: '1',
            To: '9999'
        }
        dispatch(Get_M_Ward_Wise_PillerNo_SelectTableDataAPI({ data }))
    }
    const { isLoading } = useSelector(state => state.Get_M_Ward_Wise_PillerNo_SelectTableData)

    const handleData = () => {
        setIsShowDownloadExcel(true)
    }

    const handleEditOnClick = (item) => {
        setrowData(item)
        setDesignationPopupShow(true)
        setapiFlag('Update')
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleOnCloseClick = () => {
        setDesignationPopupShow(false)
        handleIsPost()
    }

    const handleGetFinalUploadData = () => {
        // const requestOptions = {
        //     method: "GET",
        //     redirect: "follow"
        // };
        // setloader(true)
        // fetch(`${BaseUrl}/Electrical/Get_T_ELE_Excel_CurrentRating_Tempdata_Select?T_ELE_Excel_CurrentRating_TempdataID=0&M_FinancialYearID=${FinancialYear?.ID}&M_MonthID=${Month?.ID}&M_ELEC_WorkID=0&M_WardID=${WardName?.ID}&M_ELEC_PillerID=0&M_UserID=${UserID}&From=1&To=9999`, requestOptions)
        //     .then((response) => response.json())
        //     .then((result) => {
        //         if (result?.code >= 200 && result?.code <= 300 && result?.status && result?.data) {
        //             if (result?.data?.table.length > 0) {
        //                 setData(result?.data?.table)
        //                 setIsFinalVerify(true)
        //                 setloader(false)
        //             } else {
        //                 setloader(false)
        //                 setData([])
        //                 toastInfo('No Data Found')
        //             }
        //         } else {
        //             setData([])
        //             setloader(false)
        //             toastErrorr('Something Went Wrong')
        //         }
        //     })
        //     .catch((error) => {
        //         setData([])
        //         setloader(false)
        //         console.error(error)
        //     });
    }

    return (
        <>
            {isLoading && <Loading />}

            <div>
                <div id="" className="content1">
                    <div className="data_mob1">
                        <div>

                            <div className="row m-0 ">
                                <div className="col-12 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">

                                            <div className="col-12 col-md-4 col-lg-2">
                                                <FinancialYearDataDDL
                                                    FinancialYear={FinancialYear}
                                                    setFinancialYear={setFinancialYear}
                                                    col='10'
                                                />
                                            </div>

                                            <div className="col-12 col-md-4 col-lg-2">
                                                <MonthDataDDL
                                                    Month={Month}
                                                    setMonth={setMonth}
                                                    screenType="commonalldashboardreport"

                                                    col='10'
                                                />
                                            </div>

                                            <div className="col-12 col-md-4 col-lg-3">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard='0'
                                                    WLable=''
                                                    Type="Electrical"
                                                    // APIFlag="Master"
                                                    APIFlag={(RoleID == 44 || RoleID == 45 || RoleID == 46) ? "UserWiseM_Ward" : "Master"}
                                                    IsPost=''
                                                />
                                            </div>

                                            {
                                                WardName?.ID == 2 &&
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <VendorNameDDL
                                                        WardName={WardName}
                                                        VendorName={VendorName}
                                                        setVendorName={setVendorName}
                                                        APIFlag="Master"
                                                    />
                                                </div>
                                            }
                                            <div className="col-12 col-md-3 col-lg-2 mt-4">


                                                <button
                                                    disabled={WardName?.ID == 0 || FinancialYear?.ID == 0 || Month?.ID == 0}
                                                    onClick={() => handleGetData()}
                                                    className="btn btn-primary px-2"
                                                    style={{ marginTop: '2px' }}
                                                    type="button">
                                                    Search
                                                </button>

                                                <button
                                                    onClick={() => handleClear()}
                                                    className="btn btn-danger px-3 mx-1"
                                                    style={{ marginTop: '2px' }}
                                                    type="button">
                                                    Clear
                                                </button>


                                                {/* {
                                                    tableData && tableData?.table?.length > 0 ? */}

                                                {/* {
                                                    IsShowDownloadExcel ?
                                                        <ExcelPillerWiseUploadData
                                                            ExcelData={tableData}
                                                            name="Piller Wise Bench Mark"
                                                            FinancialYear={FinancialYear?.ID}
                                                            Month={Month?.ID}
                                                            setUploadData={setUploadData}
                                                        />
                                                        :
                                                        <></>
                                                } */}
                                            </div>



                                        </div>

                                        {
                                            RoleID == 1 &&
                                            <>
                                                {
                                                    IsShowDownloadExcel &&
                                                    <div className="col-12 py-3 d-flex justify-content-center">
                                                        <ExcelPillerWiseUploadData
                                                            ExcelData={tableData}
                                                            name="Piller Wise Bench Mark"
                                                            FinancialYear={FinancialYear?.ID}
                                                            Month={Month?.ID}
                                                            setUploadData={setUploadData}
                                                            RoleID={RoleID}
                                                        />
                                                    </div>
                                                }
                                            </>
                                        }

                                        <div className="row mob_table table-responsive" style={{ height: '60vh' }}>
                                            <table
                                                id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered"

                                            >
                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr.No</th>
                                                        {/* <th>M_FinancialYearID</th>
                                                        <th>M_MonthID</th> */}
                                                        <th>Ward Name</th>
                                                        {/* <th>M_ELEC_PillerID</th> */}
                                                        <th>PillerNo</th>
                                                        <th style={{ width: '12%' }}>PillerBenchMark</th>
                                                        <th>Max</th>
                                                        <th>Min</th>
                                                        <th>Remark</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData?.table?.length > 0 ? tableData?.table?.map((i, j) =>
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{j + 1}</td>
                                                                {/* <td style={{ textAlign: "center" }}>{i?.m_WardID}</td> */}
                                                                <td style={{ textAlign: "center" }}>{i?.wardName}</td>
                                                                {/* <td style={{ textAlign: "center" }}>{i?.m_eleC_PillerID}</td> */}
                                                                <td
                                                                    style={{ textAlign: "center", background: (i?.pillerNo_Validation == "0") && 'red', color: (i?.pillerNo_Validation == "0") && 'white' }}
                                                                >
                                                                    {i?.pillerNo}
                                                                </td>
                                                                <td style={{ textAlign: "right" }}>{i?.pillerBenchMark}</td>
                                                                <td style={{ textAlign: "right" }}>{i?.max}</td>
                                                                <td style={{ textAlign: "right" }}>{i?.min}</td>
                                                                <td>{i?.remark ? i?.remark : ''}</td>
                                                                <td style={{ textAlign: "center", width: '10%' }}>
                                                                    <span>
                                                                        {
                                                                            i?.t_elE_Excel_CurrentRating_TempdataID ?
                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => handleEditOnClick(i)}
                                                                                >
                                                                                </i>
                                                                                : '-'
                                                                        }

                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {
                DesignationPopupShow ?
                    <PillerWiseBenchMarkModal
                        open={DesignationPopupShow}
                        // popupHeading="Location Name"                         
                        handleIsPost={handleIsPost}
                        handleOnCloseClick={handleOnCloseClick}
                        Flag={apiFlag}
                        rowData={rowData}
                        handleGetData={handleGetData}
                        IsPost={IsPost}
                        setIsPost={setIsPost}
                    />
                    : <></>
            }

        </>
    )
}